function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import { AuthBase } from "../../../plunk/service/auth-base";
import endpoints from "../../endpoints";
import account from "../../data/account";

/*
 * Edit Contact (PlunkDocs specs/mockups/contact-management-additions.html §2).
 * PUT /v1/person/{id} {firstName, lastName, emails[], phones[]}: emails/
 * phones are FULL REPLACEMENT sets when provided. The email-collision guard
 * is server-side: 409 {error, personId, name} when an address belongs to
 * another contact: the edit fully applies or fully rejects, and the error
 * links to the owning contact (merge itself is phase 2).
 * Lifecycle stage / company link / rep assignment are deliberately absent —
 * they're engine/feed-derived, not hand-editable here.
 */

const inp = {
  width: "100%",
  boxSizing: "border-box",
  padding: "7px 9px",
  border: "1px solid #d5dbe3",
  borderRadius: "6px",
  fontSize: "13px"
};
const lbl = {
  fontSize: "12px",
  fontWeight: 600,
  display: "block",
  marginBottom: "10px"
};
export default class EditContactModal extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "addEmail", () => {
      const v = this.state.emailInput.trim();
      if (!v) return;
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
        this.setState({
          error: `“${v}” doesn't look like an email.`
        });
        return;
      }
      if (!this.state.emails.includes(v)) this.setState({
        emails: [...this.state.emails, v],
        emailInput: "",
        error: ""
      });else this.setState({
        emailInput: "",
        error: ""
      });
    });
    _defineProperty(this, "addPhone", () => {
      const v = this.state.phoneInput.trim();
      if (!v) return;
      if (!this.state.phones.includes(v)) this.setState({
        phones: [...this.state.phones, v],
        phoneInput: "",
        error: ""
      });else this.setState({
        phoneInput: "",
        error: ""
      });
    });
    _defineProperty(this, "save", async () => {
      const s = this.state;
      if (s.emails.length === 0 && s.phones.length === 0) {
        this.setState({
          error: "A contact needs at least one email or phone."
        });
        return;
      }
      this.setState({
        saving: true,
        error: "",
        conflict: null
      });
      // raw fetch (not the service layer): the 409 body carries
      // {error, personId, name} for the owning-contact link, and the
      // service layer only surfaces a bare `message`.
      try {
        const res = await fetch(`${endpoints.audience.root}/person/${this.props.personId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + (AuthBase.idToken || ""),
            "x-app-id": (account.get() || {}).tenantId || ""
          },
          body: JSON.stringify({
            firstName: s.firstName.trim(),
            lastName: s.lastName.trim(),
            emails: s.emails,
            phones: s.phones
          })
        });
        if (res.status === 409) {
          // person ids exceed 2^53: res.json() would mangle personId;
          // pull it from the raw text instead.
          const text = await res.text().catch(() => "");
          let body = {};
          try {
            body = JSON.parse(text);
          } catch (e) {/* keep {} */}
          const idMatch = text.match(/"personId"\s*:\s*(\d+)/);
          this.setState({
            saving: false,
            error: body.error || "That email belongs to another contact.",
            conflict: idMatch ? {
              personId: idMatch[1],
              name: body.name
            } : null
          });
          return;
        }
        if (!res.ok) {
          const body = await res.json().catch(() => ({}));
          throw new Error(body.error || body.message || `Save failed (HTTP ${res.status}).`);
        }
        const t = document.querySelector("paper-toast");
        if (t) t.show("Contact saved.");
        this.props.onSaved();
      } catch (err) {
        this.setState({
          saving: false,
          error: err.message || "Save failed."
        });
      }
    });
    const c = props.contact || {};
    this.state = {
      firstName: c.firstName || "",
      lastName: c.lastName || "",
      emails: (c.email || []).map(e => e.emailAddress).filter(Boolean),
      phones: (c.phone || []).map(p => p.phoneNumber).filter(Boolean),
      emailInput: "",
      phoneInput: "",
      saving: false,
      error: "",
      conflict: null // {personId, name}
    };
  }
  chipList(items, onRemove) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
        margin: "4px 0 8px"
      }
    }, items.map(v => /*#__PURE__*/React.createElement("span", {
      key: v,
      style: {
        background: "#eef2f7",
        borderRadius: "12px",
        padding: "3px 10px",
        fontSize: "12px",
        display: "inline-flex",
        alignItems: "center",
        gap: "5px"
      }
    }, v, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: "14px",
        cursor: "pointer",
        color: "#9aa4b2"
      },
      onClick: () => onRemove(v)
    }, "close"))), items.length === 0 && /*#__PURE__*/React.createElement("span", {
      className: "pcm-none"
    }, "None yet"));
  }
  render() {
    const s = this.state;
    const close = () => {
      if (!s.saving) this.props.onClose();
    };
    // Same look as the add / edit customer dialog (.pcm-* in sass/v2/_people-customers.scss).
    return /*#__PURE__*/React.createElement("div", {
      className: "pcm-overlay",
      onClick: e => {
        if (e.target === e.currentTarget) close();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "pcm-card",
      role: "dialog",
      "aria-labelledby": "ecm-title"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pcm-head"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pcm-titles"
    }, /*#__PURE__*/React.createElement("h2", {
      id: "ecm-title"
    }, "Edit contact"), /*#__PURE__*/React.createElement("span", null, this.props.contactName ? `${this.props.contactName}. ` : "", "Changes show everywhere this person appears.")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pcm-x",
      "aria-label": "Close",
      onClick: close
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "close"))), /*#__PURE__*/React.createElement("div", {
      className: "pcm-grid pairs"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pcm-field"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "ecm-first"
    }, "First name"), /*#__PURE__*/React.createElement("input", {
      id: "ecm-first",
      value: s.firstName,
      onChange: e => this.setState({
        firstName: e.target.value,
        error: ""
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "pcm-field"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "ecm-last"
    }, "Last name"), /*#__PURE__*/React.createElement("input", {
      id: "ecm-last",
      value: s.lastName,
      onChange: e => this.setState({
        lastName: e.target.value,
        error: ""
      })
    }))), /*#__PURE__*/React.createElement("div", {
      className: "pcm-field"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "ecm-email"
    }, "Emails"), this.chipList(s.emails, v => this.setState({
      emails: s.emails.filter(x => x !== v)
    })), /*#__PURE__*/React.createElement("div", {
      className: "pcm-addrow"
    }, /*#__PURE__*/React.createElement("input", {
      id: "ecm-email",
      type: "email",
      value: s.emailInput,
      placeholder: "Add an email address",
      onChange: e => this.setState({
        emailInput: e.target.value,
        error: ""
      }),
      onKeyDown: e => {
        if (e.key === "Enter") {
          e.preventDefault();
          this.addEmail();
        }
      }
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: this.addEmail
    }, "Add"))), /*#__PURE__*/React.createElement("div", {
      className: "pcm-field"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "ecm-phone"
    }, "Phones"), this.chipList(s.phones, v => this.setState({
      phones: s.phones.filter(x => x !== v)
    })), /*#__PURE__*/React.createElement("div", {
      className: "pcm-addrow"
    }, /*#__PURE__*/React.createElement("input", {
      id: "ecm-phone",
      type: "tel",
      value: s.phoneInput,
      placeholder: "Add a phone number",
      onChange: e => this.setState({
        phoneInput: e.target.value,
        error: ""
      }),
      onKeyDown: e => {
        if (e.key === "Enter") {
          e.preventDefault();
          this.addPhone();
        }
      }
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: this.addPhone
    }, "Add"))), /*#__PURE__*/React.createElement("p", {
      className: "pcm-note"
    }, "Stage, company and sales rep come from your data feeds and update on their own, so they can't be changed here."), s.error ? /*#__PURE__*/React.createElement("p", {
      className: "pcm-error",
      role: "alert"
    }, s.error, s.conflict ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement(Link, {
      to: `/Contacts/Detail/${String(s.conflict.personId)}/all_time`
    }, "Open ", s.conflict.name || "that contact")) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "pcm-foot"
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: s.saving,
      onClick: close
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: s.saving,
      onClick: this.save
    }, s.saving ? "Saving…" : "Save changes"))));
  }
}